import { EnvironmentInjector, EnvironmentProviders, Injector } from "@angular/core";
import { DataConnect, getDataConnect } from "firebase/data-connect";
import { FIREBASE_APP, REALTIME_DATA_CONNECT_INJECTOR, provideFirebase as provideFirebaseCore } from "@dis/firebase";
import { connectorConfig as defaultConnectorConfig } from "@jtms/default-connector";
import { connectorConfig as realtimeConnectorConfig } from "@dataconnect/realtime-connector";
import type { FirebaseApp } from "firebase/app";

// Re-exported so existing imports of `REALTIME_DATA_CONNECT_INJECTOR` from this file keep
// working — the token itself lives in `@dis/firebase` so shared library components (which run
// inside this app but can't import app-local files) can inject the same token this app provides.
export { REALTIME_DATA_CONNECT_INJECTOR };

export function provideFirebase(environment: any) {
  return [
    provideFirebaseCore(environment.firebase, {
      services: {
        analytics: true,
        auth: true,
        dataConnect: true,
        firestore: true,
        functions: true,
        messaging: true,
        performance: true,
        remoteConfig: true,
        storage: true,
      },
      dataConnectFactory: (app) => getDataConnect(app, defaultConnectorConfig),
    }),
    {
      provide: REALTIME_DATA_CONNECT_INJECTOR,
      useFactory: (app: FirebaseApp, parent: EnvironmentInjector) =>
        Injector.create({
          providers: [{ provide: DataConnect, useValue: getDataConnect(app, realtimeConnectorConfig) }],
          parent,
        }),
      deps: [FIREBASE_APP, EnvironmentInjector],
    },
  ];
}
